import { Card } from 'antd'
import styled from 'styled-components'

export default styled(Card)`
  background-color: ${({ theme }) => theme.colors.primaryFaded};
  border-color: ${({ theme }) => theme.colors.primaryLight};
`
